<template>
  <tr
    class="tariff"
    :class="{ 'summary': tariff.id == null, active_item: tariff.active > 0 }"
  >
    <td :data-label="translate('tariffication.tariff_name')">
      {{ tariff.tariff_name }}
    </td>
    <td :data-label="translate('tariffication.tariff_client')">
      {{ tariff.client_name }}
    </td>
    <td :data-label="translate('tariffication.tariff_descr')" class="descr" v-if="$store.getters.getPermissions.permissionGod === true">
      <p class="limit">
        {{ tariff.descr }}
      </p>
    </td>
    <td :data-label="translate('tariffication.tariff_cost_with_vat')">
      {{ tariff.cost }}
    </td>
    <td :data-label="translate('tariffication.tariff_billing')" v-if="$store.getters.getPermissions.permissionGod === true">
      {{ tariff.billing_type }}
    </td>
    <td :data-label="translate('tariffication.device_count')">
      {{ tariff.device_count }}
    </td>
    <td :data-label="translate('tariffication.simcard_count')">
      {{ tariff.simcard_count }}
    </td>
    <td :data-label="translate('tariffication.date_start')">
      {{ tariff.date_start }}
    </td>
    <td :data-label="translate('tariffication.date_end')">
      {{ tariff.date_end }}
    </td>
    <td :data-label="translate('tariffication.date_close')" :class="{ end: check_date(tariff.ts_end) }"
        v-if="$store.getters.getPermissions.permissionGod === true">
      {{ show_tariff_end_date(tariff) }}
    </td>
  </tr>
</template>

<script>

export default {
  name: "TariffListItem",
  props: [
    "tariff"
  ],
  methods:{
    check_date(ts_end) {
      let time = +new Date();
      return time / 1000 > ts_end + 86400;
    },
    show_tariff_end_date(tariff) {
      if (tariff.id !== null && tariff.ts_end != null) {
        let options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        };
        return this.get_date(tariff.ts_end, options);
      }
      return "";
    },
  }
}

</script>

<style lang="scss" scoped>
.tariff{
  td{
    font-size: 12px;
  }
  .limit{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5em;
    max-height: 3em;
    margin-bottom: 0;
    font-size: 12px;
  }
}
</style>
